var rmsApiProxyRetry = require('../../api/rmsApiProxyRetry');
var businessDateUtil = require('../../dateUtil/businessDateUtil');
var dateUtil = require('../../dateUtil/dateUtil');
var stringUtil = require('../../string/stringUtil');
var salesStatusUtil = require('./salesStatusUtil');
var stateManager = require('../../state/stateManager');
var todaysSalesUpdatedDateTimeAction = require('../../state/actions/sales/todaysSalesUpdatedDateTimeAction');



export async function loadSales(businessDate)
{
    var sales = await rmsApiProxyRetry.get(`${rmsApiProxyRetry.getOrgContextToUrl()}/accounts/sales?fromDate=${businessDate}&toDate=${businessDate}`);
    sales.forEach(sale =>
    {
        initializeSale(sale);
    })

    return sales;
}

export async function loadTodaysSalesAndSalesStatus()
{
    let salesPromise = loadSales(businessDateUtil.getTodayBusinessDate());
    let salesStatusPromise = salesStatusUtil.loadSaleStatus(businessDateUtil.getTodayBusinessDate());

    let [sales, salesStatusLines] = await Promise.all([salesPromise, salesStatusPromise]);
    if (sales == null) sales = [];
    if (salesStatusLines == null) salesStatusLines = [];

    
    
    stateManager.getStore().getState().todaySales = sales;
    stateManager.getStore().getState().todaySalesKdsStatus.clear();
    salesStatusUtil.addNewStatusLinesIfLatest(salesStatusLines);
    
    sales.forEach(sale =>
    {
        initializeSale(sale);
    })

    stateManager.getStore().dispatch(todaysSalesUpdatedDateTimeAction.createAction());
    return Promise.resolve(true);
}


export async function initializeSale(sale)
{
    initializeSaleDueDateTime(sale);
    updateDueDateTimeFromStatusLines(sale);
    initializeSaleActivationDateTime(sale);
    updateActivationDateTimeFromStatusLines(sale);
}

function initializeSaleDueDateTime(sale)
{
    sale.dueDateTime = sale.dateTime;

    if (dateUtil.isAfter(sale.currentPlannedDispatchDateTime, sale.dueDateTime))
        sale.dueDateTime = sale.currentPlannedDispatchDateTime;
}

function updateDueDateTimeFromStatusLines (sale)
{
    var dueDateTime = salesStatusUtil.getDueDateTimeFromStatusLines(sale.id);
    if (!stringUtil.isStringNullOrEmpty(dueDateTime))
        sale.dueDateTime = dueDateTime;
}

export function initializeSaleActivationDateTime(sale)
{
    var activationThresholdInMinutes = salesStatusUtil.getOrderActivationThresholdInMinutes(sale);

    sale.activationDateTime = dateUtil.addMinutes(sale.dateTime, activationThresholdInMinutes);
    if (dateUtil.isSameOrBefore(sale.dueDateTime, sale.activationDateTime))
    {
        sale.activationDateTime = sale.dateTime;
    }

    sale.activationDateTime = dateUtil.addMinutes(sale.dueDateTime, -1 * activationThresholdInMinutes);
}

export function updateActivationDateTimeFromStatusLines (sale)
{
    var activationDateTime = salesStatusUtil.getActivationDateTimeFromStatusLines(sale.id);
    if (!stringUtil.isStringNullOrEmpty(activationDateTime))
        sale.activationDateTime = activationDateTime;
}
